export const stringKeyToString = (key: string): string => {
  return key
    .split(/(?=[A-Z])/)
    .map((word) => word.toLowerCase())
    .join(" ")
    .replace(/^\w/, (c) => c.toUpperCase());
};
